(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbSubformHeader', fbSubformHeader);

    const template = `
        <div ng-if="!vm.element.subfields.options.hide_header" class="subform-header mb-2">
            <h4 ng-bind-html="vm.element.label | trustAsHtml"></h4>
            <div class="subform-header-options" ng-if="vm.element.subfields.options.actions">
                <custom-dropdown-list dark list="vm.element.subfields.options.actions"></custom-dropdown-list>
            </div>
        </div>
    `;

    function fbSubformHeader() {
        return {
            restrict: 'E',
            controller: fbSubformHeaderCtrl,
            controllerAs: 'vm',
            scope: {
                element: '='
            },
            bindToController: true,
            template: template
        };
    }

    function fbSubformHeaderCtrl() {
        var vm = this;
    }
})();